export default __webpack_public_path__ + "static/media/102.bfdba7aa.jpeg";